import styled from '@emotion/styled';

const StyledTitle = styled.div`
  font-size: 12px;
  font-weight: 0;
  line-height: 18px;
  flex-grow: 1;
  margin-left: 8px;
`;

const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--dk-bg-strong, #e7e9ec);
`;

const FileWrapper = styled.div<{ mobileMode: boolean }>`
  display: flex;
  flex-direction: ${({ mobileMode }) => (mobileMode ? 'row' : 'column')};
  gap: 8px;
  padding: ${({ mobileMode }) => (mobileMode ? '' : '0px 16px 16px 16px')};
  flex-wrap: ${({ mobileMode }) => (mobileMode ? 'wrap' : '')};
`;

const FileContainer = styled.div`
  display: flex;
  border: 4px;
  padding: 4px 8px 4px 4px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: content-box;
  border-radius: 4px;
`;

const Container = styled.div`
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid var(--dk-line, #e7e9ec);
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  padding: 16px;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;

const StyledButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
`;

export {
  StyledTitle,
  StyledButtonsContainer,
  Divider,
  FileWrapper,
  FileContainer,
  Container,
  Wrapper,
  StyledButton,
};
